import React from 'react'
import { useNavigate } from 'react-router-dom'
import { rmnAiPresenceReportEndpoint, rmnAiPresenceReportsEndpoint } from '../../api/endpoints'
import { MainContainer } from '../../components/ContentWrapper'
import { ListPageHeader } from '../../components/ListPageHeader/ListPageHeader'
import { AiPresenceHistorySection } from '../../components/AiPresence/AiPresenceHistorySection'
import { useNetworkScope } from '../../hooks/useNetworkScope'
import { AiPresenceAudit } from '../../types/aiPresence'

// Intelligence > AI Presence History: the client's AI Presence runs (brand
// runs + standalone product runs) with view / PDF / Create strategy. Runs start from the
// Catalog pages and product rows; this page gives every brand plan the
// history, the sibling of RmnConsumerVoiceHistoryPage.
export default function RmnAiPresenceHistoryPage() {
  const navigate = useNavigate()
  const { basePath, isNetwork } = useNetworkScope()

  // Same hand-off as Consumer Voice History: the strategy wizard reads ?aip=<id>.
  const createStrategy = (audit: AiPresenceAudit) => {
    const params = new URLSearchParams({ aip: String(audit.id) })
    if (audit.desireid) params.set('desireid', String(audit.desireid))
    navigate(`${basePath}/opportunities/strategies/new?${params.toString()}`)
  }
  return (
    <MainContainer>
      <ListPageHeader title="AI Presence History" subtitle="Past AI Presence analyses, newest first" />
      <AiPresenceHistorySection
        listEndpoint={rmnAiPresenceReportsEndpoint}
        itemEndpoint={rmnAiPresenceReportEndpoint}
        title="AI Presence Reports"
        onCreateStrategy={createStrategy}
        emptyMessage={isNetwork
          ? 'No AI Presence analyses yet — run one from a brand or product row.'
          : 'No AI Presence analyses yet — run one from a product row.'}
      />
    </MainContainer>
  )
}
